import { makeObservable, observable } from "mobx"

import { LockRewardStore } from "@/domains/lock-rewards/lock-reward-store"

export class LockRewardRepository {
  rewards = new Map<string, LockRewardStore>()

  constructor() {
    makeObservable(this, {
      rewards: observable,
    })
  }

  add(reward: LockRewardStore): void {
    const existing = this.rewards.get(reward.key)

    if (existing) {
      return
    }

    this.rewards.set(reward.key, reward)
  }

  upsert(reward: LockRewardStore): void {
    const existing = this.rewards.get(reward.key)

    if (existing) {
      existing.amount = reward.amount
    } else {
      this.add(reward)
    }
  }

  remove(key: string): void {
    const reward = this.rewards.get(key)
    if (reward) {
      this.rewards.delete(key)
    }
  }

  getAll(): LockRewardStore[] {
    return Array.from(this.rewards.values())
  }

  getByNftId(nftId: number): LockRewardStore[] {
    return this.getAll().filter((reward) => reward.nftId === nftId)
  }

  getByToken(tokenAddress: string): LockRewardStore[] {
    return this.getAll().filter((reward) => reward.token.address.equalsString(tokenAddress))
  }

  getByPool(poolAddress: string): LockRewardStore[] {
    return this.getAll().filter((reward) => reward.poolAddress.equalsString(poolAddress))
  }

  clearForNftId(nftId: number): void {
    const rewardsToRemove = this.getByNftId(nftId)
    rewardsToRemove.forEach((reward) => {
      this.rewards.delete(reward.key)
    })
  }

  clearAll(): void {
    this.rewards.clear()
  }

  get totalCount(): number {
    return this.rewards.size
  }

  get totalRewardsValueUSD(): number {
    return this.getAll().reduce((total, reward) => total + reward.valueUSD, 0)
  }

  getNftTotalValueUSD(nftId: number): number {
    return this.getByNftId(nftId).reduce((total, reward) => total + reward.valueUSD, 0)
  }
}
